import { useMemo } from 'react';
import { Tag } from '../../../hooks/useTags';
import type { Resource } from '../../../hooks/useResources';
import type { ListenerAudio } from '../../../hooks/useListenerAudio';

export const useTagMap = (tags: Tag[] | undefined): Map<number, Tag> => {
  return useMemo(() => {
    const map = new Map<number, Tag>();
    tags?.forEach((tag) => map.set(tag.id, tag));
    return map;
  }, [tags]);
};

export function getListenerAudioTagNames(experience: ListenerAudio, tagMap?: Map<number, Tag>): string[] {
  if (experience.tag_names?.length) return experience.tag_names;
  return (experience.topic_tag_ids || [])
    .map((id) => tagMap?.get(id)?.name)
    .filter((name): name is string => typeof name === 'string' && name.length > 0);
}

export function getResourceTagNames(resource: Resource, tagMap?: Map<number, Tag>): string[] {
  const names = new Set<string>();
  (resource.tag_ids || []).forEach((id) => {
    const name = tagMap?.get(id)?.name;
    if (name) names.add(name);
  });
  resource.tag_names?.forEach((name) => name && names.add(name));
  resource.resource_tags?.forEach((rt) => {
    const name = rt.topic?.name;
    if (name) names.add(name);
  });
  return Array.from(names);
}
